module.exports = __webpack_public_path__ + "assets/logo-hero.68c8892a.svg";